/* Orya - comprar direto da listagem.
 * Acrescenta escolha de versao e botao de adicionar ao carrinho a cada cartao
 * de produto, e um seletor de versao na pagina do produto. */
(() => {
  const lang = () => { try { return localStorage.getItem('orya-language') === 'en' ? 'en' : 'pt'; } catch (_) { return 'pt'; } };
  const T = {
    add: { en: 'Add to cart', pt: 'Adicionar ao carrinho' },
    adding: { en: 'Adding...', pt: 'A adicionar...' },
    added: { en: 'Added to cart', pt: 'Adicionado ao carrinho' },
    sold: { en: 'Sold out', pt: 'Esgotado' },
    err: { en: 'Could not add. Try again.', pt: 'Nao foi possivel adicionar. Tente outra vez.' },
    version: { en: 'Version', pt: 'Versao' },
    details: { en: 'See details', pt: 'Ver detalhes' },
    cart: { en: 'Go to cart', pt: 'Ir para o carrinho' }
  };
  const t = (k) => T[k][lang()];
  const say = (el, k) => { el.dataset.oryaT = k; el.textContent = t(k); };
  const retranslate = () => document.querySelectorAll('[data-orya-t]').forEach((el) => { el.textContent = t(el.dataset.oryaT); });

  const money = (cents) => {
    try { return new Intl.NumberFormat(lang() === 'en' ? 'en-IE' : 'pt-PT', { style: 'currency', currency: 'EUR' }).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2) + ' EUR'; }
  };

  const cache = new Map();
  const getProduct = (handle) => {
    if (!cache.has(handle)) cache.set(handle, fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null));
    return cache.get(handle);
  };

  const updateCartCount = async () => {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.querySelectorAll('.site-header a[href="/cart"]').forEach((link) => {
        let badge = link.querySelector('[data-orya-cart-count]');
        if (!badge) {
          badge = document.createElement('span');
          badge.setAttribute('data-orya-cart-count', '');
          badge.setAttribute('data-no-localize', '');
          link.appendChild(badge);
        }
        badge.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
        badge.hidden = cart.item_count === 0;
      });
    } catch (_) {}
  };

  const buildSelect = (product) => {
    const usable = product.variants.filter((v) => v.available);
    if (usable.length < 2) return null;
    const select = document.createElement('select');
    select.className = 'orya-buy-select';
    select.setAttribute('data-no-localize', '');
    select.setAttribute('aria-label', t('version'));
    usable.forEach((v) => {
      const o = document.createElement('option');
      o.value = String(v.id);
      o.textContent = v.public_title || v.title;
      select.appendChild(o);
    });
    const pt = usable.find((v) => /portugu/i.test(v.public_title || v.title || ''));
    if (pt && lang() === 'pt') select.value = String(pt.id);
    return select;
  };

  const addToCart = async (id, button, note) => {
    button.disabled = true;
    say(button, 'adding');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      say(button, 'add');
      button.disabled = false;
      if (note) { note.hidden = false; say(note.firstElementChild, 'added'); }
      updateCartCount();
    } catch (_) {
      say(button, 'add');
      button.disabled = false;
      if (note) { note.hidden = false; say(note.firstElementChild, 'err'); }
    }
  };

  const enhanceCard = async (card) => {
    if (card.dataset.oryaBuy) return;
    const footer = card.querySelector('.card-footer');
    const link = footer && footer.querySelector('a[href*="/products/"]');
    if (!footer || !link) return;
    const handle = link.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
    const product = await getProduct(handle);
    if (!product) return;
    card.dataset.oryaBuy = '1';

    const box = document.createElement('div');
    box.className = 'orya-buy-box';

    const select = buildSelect(product);
    if (select) box.appendChild(select);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button dark orya-buy-button';
    const available = product.variants.some((v) => v.available);
    if (available) { say(button, 'add'); } else { say(button, 'sold'); button.disabled = true; }
    box.appendChild(button);

    const note = document.createElement('p');
    note.className = 'orya-buy-note';
    note.hidden = true;
    const noteText = document.createElement('span');
    note.appendChild(noteText);
    const cartLink = document.createElement('a');
    cartLink.href = '/cart';
    say(cartLink, 'cart');
    note.appendChild(cartLink);
    box.appendChild(note);

    const details = document.createElement('a');
    details.className = 'orya-buy-details';
    details.href = link.getAttribute('href');
    say(details, 'details');

    button.addEventListener('click', () => {
      const first = product.variants.find((v) => v.available) || product.variants[0];
      addToCart(select ? select.value : first.id, button, note);
    });

    link.remove();
    footer.appendChild(box);
    footer.appendChild(details);
  };

  const enhanceProductPage = async () => {
    const form = document.querySelector('.orya-buy-row form[action*="/cart/add"]');
    if (!form || form.dataset.oryaBuy) return;
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return;
    const product = await getProduct(match[1]);
    if (!product) return;
    form.dataset.oryaBuy = '1';
    const select = buildSelect(product);
    if (!select) return;
    const hidden = form.querySelector('input[name="id"]');
    const price = document.querySelector('.orya-buy-row .orya-price');
    const sync = () => {
      if (hidden) hidden.value = select.value;
      const v = product.variants.find((x) => String(x.id) === select.value);
      if (v && price) price.textContent = money(v.price);
    };
    select.addEventListener('change', sync);
    form.insertBefore(select, form.firstChild);
    sync();
  };

  const run = () => {
    document.querySelectorAll('[data-orya-product-card]').forEach(enhanceCard);
    enhanceProductPage();
    updateCartCount();
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-orya-lang-button]')) setTimeout(retranslate, 0);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
